<app-slide-in-modal #modal size="md">
  <ng-container title>
    <ng-container i18n>Modifier une police</ng-container>
  </ng-container>

  <form
    (ngSubmit)="submitPolicyUpdate()"
    [id]="formId"
    class="lty-form"
    body
    [formGroup]="updatePolicyForm"
  >
    <div class="modal-body">
      <div class="split-form-body">
        <div class="form-group flex-basis-100">
          <label for="update-policy-id" i18n
            >Numéro de police <span class="text-danger">*</span></label
          >
          <input
            id="update-policy-id"
            class="form-control"
            type="text"
            formControlName="policyId"
          />
        </div>

        <div class="form-group flex-basis-100">
          <label for="update-policy-insurance-type" i18n
            >Type d'assurance <span class="text-danger">*</span></label
          >
          <select
            id="update-policy-insurance-type"
            class="form-control form-select"
            formControlName="insuranceType"
          >
            <option [ngValue]="null" i18n>Choisir un type d'assurance</option>
            <option
              *ngFor="let insuranceType of insuranceTypeOptions"
              [ngValue]="insuranceType"
            >
              {{ getInsuranceTypeLabel(insuranceType) }}
            </option>
          </select>
        </div>

        <div class="form-group flex-basis-50">
          <label for="update-policy-start-date" i18n
            >Date de début <span class="text-danger">*</span></label
          >
          <input
            id="update-policy-start-date"
            class="form-control"
            type="date"
            formControlName="startDate"
          />
        </div>

        <div class="form-group flex-basis-50">
          <label for="update-policy-end-date" i18n
            >Date de fin <span class="text-danger">*</span></label
          >
          <input
            id="update-policy-end-date"
            class="form-control"
            type="date"
            formControlName="endDate"
          />
        </div>

        <div class="form-group flex-basis-100">
          <label for="update-policy-offer-signature-date" i18n
            >Date de signature de l'offre</label
          >
          <input
            id="update-policy-offer-signature-date"
            class="form-control"
            type="date"
            formControlName="offerSignatureDate"
          />
        </div>

        <ng-container [formGroup]="products">
          <div class="form-subtitle flex-basis-100 mb-16" i18n>
            Type de produit
          </div>
          <app-product-selection
            #productSelectionComponent
            [productForm]="products"
            [insuranceType]="updatePolicyForm.controls.insuranceType.value!"
            [partnerId]="products.value.partnerId || ''"
            [agentId]="products.value.agent || ''"
          />

          <div class="form-group flex-basis-100">
            <label for="update-policy-covers-periodicity" i18n
              >Périodicité des couvertures sur document</label
            >
            <select
              id="update-policy-covers-periodicity"
              class="form-control form-select"
              formControlName="coversPeriodicity"
            >
              <option *ngFor="let value of Periodicity" [ngValue]="value">
                {{ getPeriodicityLabel(value) }}
              </option>
            </select>
          </div>

          <div class="form-group flex-basis-50">
            <label for="update-policy-periodicity" i18n
              >Fréquence de paiement <span class="text-danger">*</span></label
            >
            <select
              id="update-policy-periodicity"
              class="form-control form-select"
              formControlName="periodicity"
            >
              <option value="" i18n>Choisir une périodicité</option>
              <option *ngFor="let value of Periodicity" [ngValue]="value">
                {{ getPeriodicityLabel(value) }}
              </option>
            </select>
          </div>

          <div class="form-group flex-basis-50">
            <label for="update-policy-premium" i18n
              >Montant de la prime <span class="text-danger">*</span></label
            >
            <input
              id="update-policy-premium"
              class="form-control"
              type="number"
              min="0"
              step="0.01"
              formControlName="premiumAmount"
            />
          </div>

          <div class="form-group flex-basis-50">
            <label for="update-policy-total" i18n
              >Montant total <span class="text-danger">*</span></label
            >
            <input
              id="update-policy-total"
              class="form-control"
              type="number"
              min="0"
              step="0.01"
              formControlName="totalAmount"
            />
          </div>
        </ng-container>

        <div class="form-group flex-basis-100">
          <label for="update-policy-file" class="file-label" i18n
            >Document de police</label
          >
          <div class="file alternate">
            <input
              id="update-policy-file"
              type="file"
              class="file-input"
              (change)="onFileUpload($event)"
              multiple
            />
            <div class="upload-icon">
              <app-upload-cloud-icon
                height="20px"
                width="20px"
                color="var(--gray-600)"
              />
            </div>
            <span>
              <span class="highlighted-text" i18n
                >Cliquez pour télécharger
              </span>
              <ng-container i18n>ou glissez un fichier</ng-container>
            </span>
          </div>

          <div *ngIf="files.length > 0" class="mt-28">
            <span class="mb-16 file-label" i18n>Nouveaux documents</span>
            <div
              class="uploaded-file-container mb-8"
              *ngFor="let uploadedFile of files; let i = index"
            >
              <div class="uploaded-file-element">
                <app-file-icon
                  height="20px"
                  width="20px"
                  color="var(--gray-400)"
                />
                <div class="file-name">
                  <span>{{ uploadedFile.name }}</span>
                  <span>{{ uploadedFile.size | fileSize: 1 }}</span>
                </div>
                <app-check-circle-icon
                  height="16px"
                  width="16px"
                  color="var(--success-500)"
                />
              </div>
              <app-trash-icon
                class="clickable"
                (click)="removeFile(i)"
                (keydown.enter)="removeFile(i)"
                (keydown.space)="removeFile(i)"
                tabindex="0"
                role="button"
                height="24px"
                width="24px"
                color="var(--gray-400)"
              />
            </div>
          </div>

          <div *ngIf="existingDocs.length > 0" class="mt-16">
            <span class="mb-16 file-label" i18n>Documents actuels</span>
            <div
              class="uploaded-file-container mb-8"
              *ngFor="let existingDoc of existingDocs; let i = index"
            >
              <button
                type="button"
                class="uploaded-file-element clickable"
                (click)="viewFile(existingDoc.url)"
              >
                <app-file-icon
                  height="20px"
                  width="20px"
                  color="var(--gray-400)"
                />
                <div class="file-name">
                  <span>{{ getFileName(existingDoc.url) }}</span>
                </div>
                <app-check-circle-icon
                  height="16px"
                  width="16px"
                  color="var(--success-500)"
                />
              </button>
              <app-trash-icon
                class="clickable"
                (click)="removeExistingDoc(i)"
                (keydown.enter)="removeExistingDoc(i)"
                (keydown.space)="removeExistingDoc(i)"
                tabindex="0"
                role="button"
                height="24px"
                width="24px"
                color="var(--gray-400)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="modal-submit-buttons" footer>
    <button
      type="button"
      class="lty-btn lty-btn-white ms-auto"
      (click)="closeModal()"
      i18n
    >
      Annuler
    </button>
    <button
      [attr.form]="formId"
      type="submit"
      class="lty-btn lty-btn-primary"
      [disabled]="!canSubmit()"
    >
      <ng-container i18n>Sauvegarder</ng-container>
    </button>
  </div>
</app-slide-in-modal>

<app-pdf-viewer-modal #pdfViewer />
